
import {
  Component,
  DestroyRef,
  OnInit,
  WritableSignal,
  computed,
  inject,
  signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ThemeColor } from '@jeppesen-foreflight/jmkw-types';
import { AbstractLegend } from '@jeppesen-foreflight/jmkw-toolkit';

const STANDARD_ELEVATION_VALUES = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '07',
  '09',
  '12',
  '16',
  '20'
];
const METRIC_ELEVATION_VALUES = [
  '0.0',
  '0.3',
  '0.6',
  '0.9',
  '1.2',
  '1.5',
  '2.1',
  '2.7',
  '3.7',
  '4.9',
  '6.1'
];

@Component({
  selector: 'jmkw-terrain-legend',
  templateUrl: './terrain-legend.component.html',
  styleUrls: ['./terrain-legend.component.scss'],
  standalone: true,
  imports: []
})
export class TerrainLegendComponent extends AbstractLegend implements OnInit {
  private _destroyRef = inject(DestroyRef);
  theme: WritableSignal<ThemeColor> = signal('dark');

  elevationValues = computed(() =>
    this.toolkitApiService.getUnitConfig().distance === 'METERS'
      ? METRIC_ELEVATION_VALUES
      : STANDARD_ELEVATION_VALUES
  );
  unitString = computed(() =>
    this.toolkitApiService.getUnitConfig().distance === 'METERS'
      ? 'Elevation in km.'
      : 'Elevation by 1000 ft.'
  );

  override ngOnInit(): void {
    this.setupBasemapSubscription();
  }

  private setupBasemapSubscription(): void {
    this.toolkitApiService
      .currentBasemap$()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((basemap) => {
        this.theme.set(basemap.theme);
      });
  }
}
